import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../Common/Pagination/Pagination";
import { toast } from "react-toastify";
import PrivateOrderStatus from "./PrivateOrderStatus";

import GovtOrderStatus from "./GovtOrderStatus";
import TKCSOrderStatus from "./TKCSOrderStatus";
import GovtSupplyStatus from "./SupplyStatus/GovtSupplyStatus";
import TKCSSupplyStatus from "./SupplyStatus/TKCSSupplyStatus";
import PrivateSupplyStatus from "./SupplyStatus/PrivateSupplyStatus";
const SupplyStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [showGovt, setShowGovt] = useState(false);
  const [showPrivate, setShowPrivate] = useState(true);
  const [showTKCS, setShowTKCS] = useState(false);

  useEffect(() => {
    const storedTab = Cookies.get("supplySelectedTab");
    if (storedTab) {
      const parsedTab = JSON.parse(storedTab);
      setShowGovt(parsedTab.showGovt);
      setShowPrivate(parsedTab.showPrivate);
      setShowTKCS(parsedTab.showTKCS);
    }
  }, []);
  const handleSwitchTabs = (tab) => {
    if (tab === "govt") {
      setShowGovt(true);
      setShowPrivate(false);
      setShowTKCS(false);
    } else if (tab === "private") {
      setShowGovt(false);
      setShowPrivate(true);
      setShowTKCS(false);
    } else if (tab === "tkcs") {
      setShowGovt(false);
      setShowPrivate(false);
      setShowTKCS(true);
    }
    Cookies.set(
      "supplySelectedTab",
      JSON.stringify({
        showGovt: tab === "govt" ? true : false,
        showPrivate: tab === "private" ? true : false,
        showTKCS: tab === "tkcs" ? true : false,
      })
    );
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body dashboard-tabs p-0">
              <ul
                className="nav nav-tabs px-4 border-left-0 border-top-0 border-right-0"
                role="tablist"
              >
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("govt")}
                >
                  <a
                    className={`nav-link ${showGovt ? "active" : ""}`}
                    id="govt-tab"
                    data-toggle="tab"
                    href="#govt"
                    role="tab"
                    aria-controls="private"
                    aria-selected="true"
                  >
                    Govt Supply Status
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("private")}
                >
                  <a
                    className={`nav-link ${showPrivate ? "active" : ""}`}
                    id="private-tab"
                    data-toggle="tab"
                    href="#private"
                    role="tab"
                    aria-controls="tkcs"
                    aria-selected="false"
                  >
                    Private Supply Status
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("tkcs")}
                >
                  <a
                    className={`nav-link ${showTKCS ? "active" : ""}`}
                    id="tkcs-tab"
                    data-toggle="tab"
                    href="#tkcs"
                    role="tab"
                    aria-controls="tkcs"
                    aria-selected="false"
                  >
                    TKCS Supply Status
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showGovt && (
        <div data-aos="fade-in">
          <GovtSupplyStatus
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
      {showTKCS && (
        <div data-aos="fade-in">
          <TKCSSupplyStatus
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
      {showPrivate && (
        <div data-aos="fade-in">
          <PrivateSupplyStatus
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
    </>
  );
};

export default SupplyStatus;
